export class AppOverlay extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
        this.setupEvents();
    }

    show() {
        this.shadowRoot.getElementById('overlay').classList.remove('hidden');
    }

    hide() {
        this.shadowRoot.getElementById('overlay').classList.add('hidden');
    }

    setupEvents() {
        const closeBtn = this.shadowRoot.getElementById('close-btn');
        const closeBtnX = this.shadowRoot.getElementById('close-btn-x');
        const overlay = this.shadowRoot.getElementById('overlay');
        const content = this.shadowRoot.querySelector('.content');
        const reportBtn = this.shadowRoot.getElementById('report-btn');

        const hideHandler = () => this.hide();

        // Prevent interaction with performance surface
        const stopProp = (e) => e.stopPropagation();
        overlay.addEventListener('mousedown', stopProp);
        overlay.addEventListener('touchstart', stopProp, { passive: true });
        overlay.addEventListener('click', stopProp);

        closeBtn.addEventListener('click', hideHandler);
        closeBtnX.addEventListener('click', hideHandler);
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) hideHandler();
        });
        
        reportBtn.addEventListener('click', () => {
             const version = document.getElementById('app-version')?.textContent;
             window.open(`mailto:bugs@sonicenv.app?subject=Bug Report: Sonic Envelope v${version}`, '_blank');
        });
    }

    render() {
        const version = document.getElementById('app-version')?.textContent;
        
        // CSS
        const style = `
            <style>
                :host {
                    z-index: 2000;
                    position: relative;
                }
                #overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.6);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    opacity: 1;
                    transition: opacity 0.3s ease;
                    z-index: 2000;
                }
                #overlay.hidden {
                    opacity: 0;
                    pointer-events: none;
                }
                .content {
                    background: rgba(20, 20, 20, 0.9);
                    border: 1px solid rgba(0, 255, 204, 0.3);
                    border-radius: 16px;
                    padding: 40px;
                    width: 90%;
                    max-width: 500px;
                    text-align: center;
                    box-shadow: 0 0 50px rgba(0, 0, 0, 0.8), 0 0 15px rgba(0, 255, 204, 0.2);
                    position: relative;
                    transform: translateY(0);
                    transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }
                #overlay.hidden .content {
                    transform: translateY(20px);
                }
                h2 {
                    color: #00ffcc;
                    margin: 20px 0 10px;
                    font-family: 'Courier New', monospace;
                    text-transform: uppercase;
                    letter-spacing: 3px;
                }
                p {
                    color: #ccc;
                    font-family: 'Courier New', monospace;
                    line-height: 1.6;
                    font-size: 0.9rem;
                }
                .meta {
                    color: #666;
                    font-size: 0.8rem;
                    margin-bottom: 30px;
                }
                .btn-group {
                    display: flex;
                    gap: 15px;
                    justify-content: center;
                    margin-top: 25px;
                }
                button {
                    background: transparent;
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    color: #fff;
                    padding: 10px 20px;
                    border-radius: 4px;
                    font-family: inherit;
                    cursor: pointer;
                    transition: all 0.2s;
                    text-transform: uppercase;
                    font-size: 0.8rem;
                    letter-spacing: 1px;
                }
                button.primary {
                    border-color: #00ffcc;
                    color: #00ffcc;
                }
                button:hover {
                    background: rgba(255, 255, 255, 0.1);
                    transform: translateY(-2px);
                }
                button.primary:hover {
                    background: rgba(0, 255, 204, 0.1);
                    box-shadow: 0 0 15px rgba(0, 255, 204, 0.3);
                }
                #close-btn-x {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    background: none;
                    border: none;
                    color: #666;
                    font-size: 1.5rem;
                    padding: 0;
                    cursor: pointer;
                }
                #close-btn-x:hover {
                    color: #fff;
                }
            </style>
        `;

        // HTML
        const html = `
            <div id="overlay" class="hidden">
                <div class="content">
                    <button id="close-btn-x">×</button>
                    <app-logo class="large"></app-logo>
                    <h2>Sonic Envelope</h2>
                    <p class="meta">Version ${version}</p>
                    <p>
                        An experimental touch-first synthesizer designed for the modern web. 
                        Explore new sonic territories with gesture-controlled audio synthesis.
                    </p>
                    <div class="btn-group">
                        <button id="report-btn" class="primary">Report Bug</button>
                        <button id="close-btn">Close</button>
                    </div>
                </div>
            </div>
        `;

        this.shadowRoot.innerHTML = style + html;
    }
}

customElements.define('app-overlay', AppOverlay);
